import { Component, ElementRef, ViewChild, Input, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { AppEventService } from '../../app/app-events';
import { SearchCharacteristic, SearchCharacteristicWithType, SearchType } from "../../models/models";

import { RefdataProvider } from "../../providers/refdata/refdata";
import { SvgProvider } from '../../providers/svg/svg';
import { BhutilProvider } from '../../providers/bhutil/bhutil';

import * as $ from 'jquery';
import { BeerHiveSearchProvider } from '../../providers/beer-hive-search/beer-hive-search';
import { BeerHiveAnalysisProvider } from '../../providers/beer-hive-analysis/beer-hive-analysis';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

enum ButtonTypes {
  DETAILS_BUTTON,
  DETAILS_CHILD,
  NONE,
  PARENT,
  ONE_TO_FIVE_PARENT,
  ONE_TO_FIVE_CHILD,
  BINARY_ONLY,
  COLOR_PARENT,
  COLOR_CHILD,
}

@Component({
  selector: 'beer-hive',
  templateUrl: 'beer-hive.html',
  styleUrls: ['./beer-hive.scss'],
  standalone: false,
  imports: [
  //   CommonModule,
  //   IonicModule,
  //   FormsModule,
  //   TranslateModule
  ]
})

export class BeerHiveComponent implements OnInit, AfterViewInit, OnDestroy {
  //dit zijn de members van de klasse
  @Input() public type: string;//input variabele, komt binnen via attribuut
  buttons: Array<any>;
  size: number;
  yOffsetFull: number;
  yOffsetHalf: number;
  xOffset: number;
  startX: number;
  startY: number;
  shouldPublish: boolean = true;
  public timestamp;
  //isVisible: boolean = true;

  private setCharacteristicsSubscription: any;
  private updateMouthfeelSubscription: any;
  private removeHiveSubscription: any;
  private resetMoutfeelSubscription: any;
  private clearAnalysisSubscription: any;

  eventHandlers: Array<any> = new Array<any>();

  //hier worden gewoon alle knoppen aangemaakt, dit is eigenlijk straightforward code
  constructor(
    private events: AppEventService,
    private refdata: RefdataProvider,
    public svgProvider: SvgProvider,
    private bhutil: BhutilProvider,
    private searchProvider: BeerHiveSearchProvider,
    private analysisProvider: BeerHiveAnalysisProvider
  ) {
    console.log('[beer-hive] - constructor');
    //this.isVisible = (this.type == 'search' ? false : true);

    this.removedItems = [];

    // this.initButtons();

    this.timestamp = Date.now();
  }

  subscribeEvents() {
    this.setCharacteristicsSubscription = (characteristics: any) => {
      console.log("[beer-hive] SUB set:characteristics received");
     //debugger;// set characteristics
      for (let characteristic in characteristics) {
        let index = characteristic;
        let characteristicValue = characteristics[index];
        //select the item in the hive data model
        this.selectElementMy(this.buttons, characteristicValue);
      }
      //update the hive
      //TODO
    };
    this.events.subscribe("set:characteristics", this.setCharacteristicsSubscription);

    this.updateMouthfeelSubscription = (mouthfeelEvent: any) => {
      //debugger;
      console.log("[beer-hive] SUB update:mouthfeel event received");
      let alcohol = mouthfeelEvent.alcohol;
      let astringent = mouthfeelEvent.astringent;
      let body = mouthfeelEvent.body;
      let carbonation = mouthfeelEvent.carbonation;
      let intensity = mouthfeelEvent.intensity;
      let source = mouthfeelEvent.source;

      if (source == 1) {
        console.log("no need to continue, we are not in *my* mode");
        return;
      }

      this.deselectMouthfeelButtons();

      if (alcohol != -1) {
        this.selectElementMF(this.buttons, "alcohol", alcohol);
      }

      if (astringent != -1) {
        this.selectElementMF(this.buttons, "astringent", astringent);
      }

      if (body != -1) {
        this.selectElementMF(this.buttons, "body", body);
      }

      if (carbonation != -1) {
        this.selectElementMF(this.buttons, "carbonation", carbonation);
      }

      if (intensity != -1) {
        this.selectElementMF(this.buttons, "intensity", intensity);
      }

    };
    this.events.subscribe("update:mouthfeel", this.updateMouthfeelSubscription);

    this.resetMoutfeelSubscription = (mouthfeelEvent: any) => {
      //debugger;
      console.log("[beer-hive] SUB reset:mouthfeel event received");
      let alcohol = -1;
      let astringent = -1;
      let body = -1;
      let carbonation = -1;
      let intensity = -1;

      this.deselectMouthfeelButtons();
    };
    this.events.subscribe("reset:mouthfeel", this.resetMoutfeelSubscription);

    this.removeHiveSubscription = (key: string) => {
      console.log("[beer-hive] removing search key " + key);

      this.logButtons();

      this.removeElement(this.buttons, key);

      this.refreshBeerHive();
    };
    this.events.subscribe("remove:hive", this.removeHiveSubscription);

    this.clearAnalysisSubscription = (value) => {
      //debugger;// clear hive

      //this.removeAll(this.buttons);
      //this.logButtons();
      this.deselectMouthfeelButtons();
      this.removeAll(this.buttons);
      this.initButtons();
      //this.logButtons();

      this.shouldPublish = false;
      this.searchCharacteristics = [];

      this.refreshBeerHive();
    };
    this.events.subscribe("clear:analysis", this.clearAnalysisSubscription);
  }
  private initButtons() {
    console.log("BeerHiveComponent.initButtons: type = #" + this.type + "#");
    if (!this.buttons) {
      if (this.type == "search") {
        this.buttons = this.searchProvider.getButtons();
      }
      else {
        this.buttons = this.analysisProvider.getButtons();
      }
    }
  }
  //initialisatie van de component
  ngOnInit() {
    console.log("[beer-hive] ngOnInit");
    //this.isVisible = (this.type == 'search' ? false : true);

    this.initButtons();

    this.size = this.bhutil.hiveSize(); // 32;
    this.startX = this.size;
    this.startY = this.size * 2;
    this.xOffset = this.size * 1.5;
    this.yOffsetFull = this.size * 1.75;
    this.yOffsetHalf = this.size * 1.75 / 2;

    this.activeSvg = '';
    this.buildingSvg = '';

    this.subscribeEvents();

    //this.refreshBeerHive();

    if (this.type == "search") {
      // this.buildSearchCharacteristics();
    }
  }
  ngAfterViewInit(): void {
    if (this.svgElementRef && this.svgElementRef.nativeElement) {
      console.log('Found SVG:', this.svgElementRef.nativeElement);
      this._DIV = this.svgElementRef.nativeElement;
      
      // Call your drawing/logic function here
      this.refreshBeerHive(); 
    }
    else {
      console.log('NO SVG Found!');
    }
  }

  ngOnDestroy() {
    console.log("[beer-hive] ngOnDestroy");
    this.events.unsubscribe("set:characteristics", this.setCharacteristicsSubscription);
    this.events.unsubscribe("update:mouthfeel", this.updateMouthfeelSubscription);
    this.events.unsubscribe("remove:hive", this.removeHiveSubscription);
    this.events.unsubscribe("reset:mouthfeel", this.resetMoutfeelSubscription);
    this.events.unsubscribe("clear:analysis", this.clearAnalysisSubscription);
  }

  private logButtons() {
    //debugger;
    console.log(this.buttons);
    //for()
  }

  private removeElement(buttons: Array<any>, element: any) {
    let bb = buttons;
    console.log("[beer-hive] removing element " + element + " from buttons " + bb);
    //debugger;
    /*
    for (const b of this.buttons) {
          if(b.key === key) {
            //remove this key, how?
            //debugger;
            b.selected = false;
          }

        }
        */

    let levelOfElement = false;

    for (let b of buttons) {
      let bkey = b.key;
      if (bkey === element) {
        levelOfElement = true;
      }
    }

    if (!levelOfElement) {
      console.log("[beer-hive] not at level of element...");
      for (let b of buttons) {
        //let i = 1;
        if (b.buttons && b.buttons.length > 0) {
          this.removeElement(b.buttons, element);
        }
        if (b.detailsChildren && b.detailsChildren.length > 0) {
          //debugger;
          let bkey = b.label; //b.key;
          let keyIndex = element.indexOf(bkey);
          if (keyIndex != -1) {
            //eg fruity & fruity_banana
            this.removeElement(b.detailsChildren, element);
          }
        }
      }
    } else {
      console.log("[beer-hive] at level of element!");
      for (let b of buttons) {
        let bkey = b.key;
        if (bkey === element) {//!==
          console.log("[beer-hive] deselecting " + b.key);
          b.selected = false;
          //dit was em!
          b.value = -1;
          //check for children
          if (b.buttons && b.buttons.length > 0) {
            for (let b2 of b.buttons) {
              console.log("[beer-hive] deselecting 2 " + b2.key);
              b2.selected = false;
              b2.value = -1;
            }
          }
        }
      }
    }

  }

  private removeAll(buttons: Array<any>) {
    //debugger;
    for (let b of buttons) {
      //let i = 1;
      if (b.buttons && b.buttons.length > 0) {
        this.removeAll(b.buttons);
      }
      else {
        b.value = -1;
        b.selected = false;
      }
      if (b.detailsChildren && b.detailsChildren.length > 0) {
        this.removeAll(b.detailsChildren);
      }
      else {
        b.value = -1;
        b.selected = false;
      }
    }
  }

  @ViewChild('beerHiveSvg') svgElementRef: ElementRef;

  private activeSvg: string;
  private buildingSvg: string;

  private removedItems: Array<String>;

  private searchCharacteristics: Array<SearchCharacteristicWithType>;

  private _DIV: any;

  private buildSearchCharacteristics() {
    console.log("[beer-hive]buildSearchCharacteristics()");
    this.searchCharacteristics = [];//initieel lege array
    for (const b of this.buttons) {
      this.handleButtonSearchCharacteristics(b);//handler toevoegen voor elke "knop"
    }
    //debugger;
    this.events.publish("search:beerhiveInput", this.searchCharacteristics);
  }

  private buildAnalysis() {
    console.log("[beer-hive] buildAnalysis()");
    /*f(! this.shouldPublish) {
      console.log("[beer-hive] buildAnalysis() - shouldPublish false, so nothing to do...");
      return;
    }*/

    let fruitbuttons = this.buttons[1].buttons[1].detailsChildren;
    this.searchCharacteristics = [];//initieel lege array
    for (const b of this.buttons) {
      this.handleButtonSearchCharacteristics(b);//handler toevoegen voor elke "knop"
    }

    //debugger;
    this.addRemovedItems();

    //in selectElement => op basis v type instellen of je ja/nee een publish moet doen
    if (this.searchCharacteristics.length != 0 && this.shouldPublish) {
      this.events.publish("post:analysis", this.searchCharacteristics);
      console.log("[beer-hive] PUB post:analysis => analysis characteristics: " + this.searchCharacteristics);
    }
    else {
      this.shouldPublish = true;
      console.log("[beer-hive] no action to take in buildAnalysis()");
    }

    this.removeRemovedItems();

  }

  private handleButtonSearchCharacteristics(button) {

    //debugger;
    //handler voor button clicks

    //als het een "gewone" knop is...
    //ooit was de check button.value > -1 maar dit gaf ook de mouthfeel params als characteristics (niet nodig)
    if ((button.type === ButtonTypes.ONE_TO_FIVE_PARENT || button.type === ButtonTypes.BINARY_ONLY) && button.value > 0 && button.key) {
      //debugger;
      console.log("[beer-hive] We are ADDING (1) - " + button.label + "/" + button.key);
      let searchCharacteristic: SearchCharacteristic = new SearchCharacteristic(button.key, button.value);
      let searchCharacteristicWithType: SearchCharacteristicWithType = new SearchCharacteristicWithType(SearchType.SEARCH_HIVE, searchCharacteristic);
      this.searchCharacteristics.push(searchCharacteristicWithType);
    }
    else {
      if (this.type != "search") { // only if we are making an analysis
        if (button.type === ButtonTypes.ONE_TO_FIVE_PARENT && button.selected && button.value != -1) { // added && button.selected for BEERHIVE-102
          console.log("[beer-hive] We are ADDING a zero or null value to save - " + button.label + "/" + button.key);
          let searchCharacteristic: SearchCharacteristic = new SearchCharacteristic(button.key, (button.value == null ? null : new Number(0)));
          let searchCharacteristicWithType: SearchCharacteristicWithType = new SearchCharacteristicWithType(SearchType.SEARCH_HIVE, searchCharacteristic);
          this.searchCharacteristics.push(searchCharacteristicWithType);
        }
      }
    }

    //als het een knop "kleur" is...
    /*
    if (button.type === ButtonTypes.COLOR_PARENT && button.key === "colour" && button.value) {
      let colors = ["#FFFFCD", "#FFFF01", "#FE9900", "#A94124", "#5B220E", "#FFC000", "#CC6601", "#CC0001", "#080808"];
      let values = [1, 2, 4, 6, 8, 3, 5, 7, 9];
      //TODO (Steven) , check translation of colors to values (corresponding array index ? )
      //public static final int EBC_COLOUR_0_INVALID        = -1;
      //public static final int EBC_COLOUR_1_PALE           = 1;
      //public static final int EBC_COLOUR_2_BLONDE_YELLOW  = 2;
      //public static final int EBC_COLOUR_3_GOLD           = 3;
      //public static final int EBC_COLOUR_4_AMBER          = 4;
      //public static final int EBC_COLOUR_5_BRASS          = 5;
      //public static final int EBC_COLOUR_6_BROWN          = 6;
      //public static final int EBC_COLOUR_7_RED_BROWN      = 7;
      //public static final int EBC_COLOUR_8_DARK_BROWN     = 8;
      //public static final int EBC_COLOUR_9_BLACK          = 9;


      let searchCharacteristic:SearchCharacteristic = new SearchCharacteristic(button.key, values[colors.indexOf(button.value)]);
      this.searchCharacteristics.push(new SearchCharacteristicWithType(SearchType.SEARCH_COLOUR, searchCharacteristic));
    }
    */


    //als het een clarity knop is...
    /*
    if (button.type === ButtonTypes.COLOR_PARENT && button.key === "clarity" && button.value) {
      let colors = ["#FFFFFF", "#DDDDDD", "#BBBBBB", "#999999", "#777777"];
      let values = [1, 2, 3, 4, 5];

      //TODO (Steven) , check translation of colors to values (corresponding array index ? )
      //
      //public static final int CLARITY_0_INVALID               = -1;
      //public static final int CLARITY_1_CRYSTAL_CLEAR         = 1;
      //public static final int CLARITY_2_CLEAR                 = 2;
      //public static final int CLARITY_3_CLOUDY                = 3;
      //public static final int CLARITY_4_HAZY                  = 4;
      //public static final int CLARITY_5_OPAQUE                = 5;

      let searchCharacteristic:SearchCharacteristic = new SearchCharacteristic(button.key, values[colors.indexOf(button.value)]);
      this.searchCharacteristics.push(new SearchCharacteristicWithType(SearchType.SEARCH_COLOUR, searchCharacteristic));
    }
    */

    //als het een detail button is...
    if ((button.type === ButtonTypes.ONE_TO_FIVE_PARENT || button.type === ButtonTypes.BINARY_ONLY) && button.detailsButton) {
      button.detailsChildren.forEach(c => {
        if (c.selected && c.key) {//c.value > 0
          // debugger; //hier controleren of het item ook in removedItems zit en zo ja, NIET toevoegen!
          console.log("[beer-hive] We are ADDING (2) - " + c.label + "/" + c.key);
          let searchCharacteristic: SearchCharacteristic = new SearchCharacteristic(c.key, 1);
          this.searchCharacteristics.push(new SearchCharacteristicWithType(SearchType.SEARCH_HIVE, searchCharacteristic));
        } else {
          //console.log("[beer-hive] We are NOT ADDING (2) - " + c.label + "/" + c.key);
        }
      });
    }

    //
    if (button.buttons && button.buttons.length > 0) {
      for (const b of button.buttons) {
        //recursion for child buttons
        this.handleButtonSearchCharacteristics(b);
      }
    }
  }

  addRemovedItems() {

    for (let removedItem of this.removedItems) {
      console.log("[beer-hive] We are adding REMOVED ITEM " + removedItem);
      let searchCharacteristic: SearchCharacteristic = new SearchCharacteristic(removedItem, 0);
      this.searchCharacteristics.push(new SearchCharacteristicWithType(SearchType.SEARCH_HIVE, searchCharacteristic));
    }

  }

  removeRemovedItems() {

   //debugger;
    let oldItems = this.searchCharacteristics;
    this.searchCharacteristics = [];

    //loop through all
    let itemIndex: any;
    for (itemIndex in oldItems) {
      //if type == SEARCH_COLOUR, remove
      let item = oldItems[itemIndex];
      let char = item.characteristic;
      let theIndex = this.removedItems.indexOf(char.key);
      if (theIndex != -1) {
        console.log("we need to remove this item");
      }
      else {
        console.log("no need to remove this item");
        this.searchCharacteristics.push(item);
      }
    }

    //debugger;
    /*for(let removedItem of this.removedItems) {
      console.log("[beer-hive] We are removing REMOVED ITEM " + removedItem);
      let searchCharacteristic: SearchCharacteristic = new SearchCharacteristic(removedItem, 0);
      this.searchCharacteristics.push(new SearchCharacteristicWithType(SearchType.SEARCH_HIVE, searchCharacteristic));

    }*/

    this.removedItems = [];

  }

  //clear the canvas, draw the canvas again
  public refreshBeerHive() {
    console.log('[beer-hive] - refreshBeerhive');

    this.initButtons();

    this.buildingSvg = this.svgRootElement();
    if (true) {
      this.DrawBeerhive(this.buttons, this.startX + 3, this.startY);
    }
    this.buildingSvg += '</svg>';

    this.activeSvg = this.buildingSvg;
    this._DIV.innerHTML = this.activeSvg;
    console.log('[beer-hive] - refreshed Beerhive');

    this.eventHandlers.forEach(element => {
      $('#' + element.id).on(element.event, element.data, element.handler);
    });

  }

  private DrawBeerhive(buttons: Array<any>, x: number, y: number) {
    //console.log("[beer-hive] DRAWBEERHIVE");
    //debugger;
    for (let i = 0; i < buttons.length; i++) {
      const b = buttons[i];

      b.x = x;
      b.y = y;

      this.DrawHexagon(x, y, b.selected, "");
      this.DrawImage(x, y, b.selected, b);
      this.DrawTouchHexagon(x, y, b);

      if (b.selected && b.buttons && b.buttons.length > 0 && b.type === ButtonTypes.PARENT) {
        let subX = x + this.xOffset;
        //Recursive call to draw child buttons
        this.DrawBeerhive(b.buttons, subX, this.startY - this.yOffsetHalf);
      } else if (b.selected && (b.type === ButtonTypes.ONE_TO_FIVE_PARENT || b.type === ButtonTypes.BINARY_ONLY)) {


        if (b.detailsButton && b.detailsChildren && b.buttons && b.buttons[5].selected) {
          console.log("[beer-hive] 0to5 drawing detail children for " + b.label);
          this.DrawDetailChildren(b);
        } else {
          console.log("[beer-hive] 0to5 drawing zero to five for " + b.label);
          this.DrawZeroToFive(b);
        }
      } else if (b.selected && b.type === ButtonTypes.COLOR_PARENT) {
        this.DrawColor(b);
      }
      y += this.yOffsetFull;
    }
    //this.DrawString(this._CONTEXT,"TRALALA",10,10,"#00000000",null,null,16);
    //let x1: number = 0;
    //let y1: number = 30;
    //this._CONTEXT.fillStyle="#000000";
    //this.DrawString(this._CONTEXT,"TRALALA",x1,y1,"#00000000",null,null,16)
  }

  //TODO cache
  //draw the image(s) and label(s)
  private DrawImage(x: number, y: number, isSelected: boolean, b: any) {
    // Draw SVG
    var iconScale = 0.6;
    var iconSize = this.size * 2.0 * iconScale;

    var iconX = x - iconSize / 2.0;
    var iconY = y - this.size + this.size * 0.2;
    var iIcon = this.svgProvider.drawIcon(iconX, iconY, b.svgPath, iconSize, iconSize);
    this.buildingSvg += iIcon;
    this.DrawString(b.label, x, iconY + this.size / 2.2, this.refdata.defaultFontColor, null, null, 7);


  }

  //draw the hex shapes
  private DrawHexagon(x: number, y: number, isSelected: boolean, args: any = null) {
    var fillStyle: string = 'none';
    //pick fill type
    if (isSelected) {
      fillStyle = "#ffdd58";
    }
    if (args.type === ButtonTypes.ONE_TO_FIVE_CHILD) {
      if (args.thisCell <= args.parent.value && args.parent.value != null) {
        fillStyle = "#ffdd58";
      } else {
        fillStyle = "#ffffff";
      }
    }
    // Draw svg
    var style = this.refdata.aromaHexagonBaseStyle + 'fill:' + fillStyle + ';';

    var centerX = x;
    var centerY = y;
    var hexId: string = 'hex_' + Math.round(Math.random() * 100000000);
    var hexagon = this.svgProvider.drawHexagon(hexId,
      centerX,
      centerY,
      this.size,
      style);
    this.buildingSvg += hexagon;

  }

  //draw the hex shapes
  private DrawTouchHexagon(x: number, y: number, button: any = null) {
    var centerX = x;
    var centerY = y;
    var clickId: string = 'click_hex_' + Math.round(Math.random() * 100000000);
    var hexagon = this.svgProvider.drawHexagon(clickId,
      centerX,
      centerY,
      this.size,
      'opacity:0;'); // invisible hexagon
    this.buildingSvg += hexagon;
    this.eventHandlers.push({ id: clickId, event: 'click', data: { button: button, component: this }, handler: this.aromaClickHandler });

  }

  public aromaClickHandler(event) {
    //debugger;
    console.log("[beer-hive] aroma click handler: " + event.data.button.label);

    //STEVEN - ADDED THIS
    if (event.data.button.type == ButtonTypes.PARENT) {
      //set selected to false for all child buttons
      for (let aButton of event.data.button.buttons) {
        aButton.selected = false;
      }
    }

    event.data.component.SelectElement(event.data.button);
    event.data.component.refreshBeerHive();

    if (event.data.button.detailsButton) {
      let detailElement = event.data.button.buttons[5];
      event.data.component.SelectElement(detailElement);
      event.data.component.refreshBeerHive();
      console.log("[beer-hive] we should show the binary params immediately");
      console.log("[beer-hive] GREAT, NOW MAKE SURE +, - and detail are not drawn - TODO");
    }

    if (event.data.component.type === "search") {
      console.log("[beer-hive] building search characteristics");
      event.data.component.buildSearchCharacteristics();
    }
    else {
      console.log("[beer-hive] building analysis...");
      event.data.component.buildAnalysis();
    }
    //console.log("[beer-hive] aromaClick: " + event.data.component.searchCharacteristics);
  }


  //select an item in the hive

  private selectElementMy(buttons: Array<any>, element: any) {
    // This function only selects aromas
    console.log("beer-hive - selecting button", element);

    for (let b of buttons) {
      if (b.type === ButtonTypes.PARENT) {
        for (let childB of b.buttons) {
          if (childB.type === ButtonTypes.BINARY_ONLY){
            for (let grandChildB of childB.detailsChildren) {
              if (grandChildB.key === element) {
                grandChildB.selected = true;
              }
            }
          }
        }
      }
    }
  }

  private selectElementMF(buttons: Array<any>, elementName: String, elementValue: Number) {
    // This function only selects aromas
    console.log("beer-hive - selecting button", elementName, elementValue);
    console.log(buttons);

    for (let b of buttons) {
      if (b.type === ButtonTypes.PARENT) {
        for (let childB of b.buttons) {
          if (childB.type === ButtonTypes.ONE_TO_FIVE_PARENT){
            if (childB.key === elementName) {
              childB.value = elementValue;
            }
          }
        }
      }
    }
  }

  private obsolete_selectElementMy(buttons: Array<any>, element: any) {
    //debugger;
    /*
    for (const b of this.buttons) {
          if(b.key === key) {
            //remove this key, how?
            //debugger;
            b.selected = false;
          }

        }
        */

    let levelOfElement = false;

    for (let b of buttons) {
      let bkey = b.key;
      if (bkey === element) {
        console.log("[beer-hive] selectElementMy: " + bkey + " is the level of element " + element);
        levelOfElement = true;
      }
      else {
        console.log("[beer-hive] selectElementMy: " + bkey + " is not the level of element " + element);
      }
    }

    if (!levelOfElement) {
      console.log("[beer-hive] selectElementMy - not at level of element " + element);
      for (let b of buttons) {
        //let i = 1;
        if (b.buttons && b.buttons.length > 0) {
          console.log("[beer-hive] selectElementMy - recursing in " + element);
          this.selectElementMy(b.buttons, element);
        }
        if (b.detailsChildren && b.detailsChildren.length > 0) {
          console.log("[beer-hive] selectElementMy - detailsChildren present");
          let bkey = b.label;
          let keyIndex = element.indexOf(bkey);
          if (keyIndex != -1) {
            //eg fruity & fruity_banana
            console.log("[beer-hive] selectElementMy - detailsChildren present - recursing on key " + bkey);
            this.selectElementMy(b.detailsChildren, element);
          }
          else {
            console.log("[beer-hive] selectElementMy - detailsChildren present - not recursing on bkey " + bkey);
          }
        }
      }
    } else {
      console.log("[beer-hive] selectElementMy - at level of element " + element);
      for (let b of buttons) {
        console.log("[beer-hive] selectElementMy - at level of element, checking key " + b.key);
        let bkey = b.key;
        let bkeyindex = bkey.indexOf("_");
        if (bkey === element && bkeyindex != -1) {//!==
          console.log("[beer-hive] selectElementMy - at level of binary aroma " + bkey);
         //debugger;//select 4
          b.selected = true;
          //dit was em!
          //HIER GAAT HET MIS, alcohol wordt hier op 1 gezet op een bepaald moment
          /*if(b.key === "alcohol") {
            console.log("updating alcohol where we should not!");
            //debugger;
          }*/
          //deze lijkt niet (meer) nodig???
          //console.log("set " + b.key + " to value 1");
          //b.value = 1;
          //check for children
          if (b.buttons && b.buttons.length > 0) {
            for (let b2 of b.buttons) {
              console.log("[beer-hive] selectElementMy - selecting button " + b2.key);
             //debugger;//select 3
              b2.selected = true;
              console.log("[beer-hive] selectElementMy - set " + b2.key + " to value 1");
              b2.value = 1;
            }
          }
        }
      }
    }
  }

  private obsolete_selectElementMF(buttons: Array<any>, elementName: String, elementValue: Number) {
    let levelOfElement = false;

    if(elementValue != 0) {
      //debugger;
      console.log("[beer-hive] selectElementMF - value is not 0 => check which one!");
    }

    for (let b of buttons) {
      let bkey = b.key;
      if (bkey === elementName) {
        //debugger;
        levelOfElement = true;
      }
    }

    if (!levelOfElement) {
      console.log("[beer-hive] selectElementMF not at level of element...");
      for (let b of buttons) {
        //let i = 1;
        //debugger;
        if (b.buttons && b.buttons.length > 0) {
          console.log("[beer-hive] selectElementMF recursing to " + elementName);
          this.selectElementMF(b.buttons, elementName, elementValue);
        }
        if (b.detailsChildren && b.detailsChildren.length > 0) {
          let bkey = b.label;
          let keyIndex = elementName.indexOf(bkey);
          if (keyIndex != -1) {
            //eg fruity & fruity_banana
          console.log("[beer-hive] selectElementMF recursing to child " + elementName);
            this.selectElementMF(b.detailsChildren, elementName, elementValue);
          }
        }
      }
    } else {
      console.log("[beer-hive] selectElementMF - at level of element!");
      for (let b of buttons) {
        let bkey = b.key;
        if (bkey === elementName) {//!==
          console.log("[beer-hive] selectelementMF - selecting element " + b.key);
          console.log("[beer-hive] selectelementMF - set " + b.key + " to value " + elementValue);
          b.value = elementValue;
          //check for children
          /*if (b.buttons && b.buttons.length > 0) {
            //debugger;
            for (let b2 of b.buttons) {
              //b2.selected = true;
              //b2.value = 1;
            }
          }*/
        }
      }
    }

  }

  private deselectMouthfeelButtons() {
    this.deselectElementMF(this.buttons, "alcohol");
    this.deselectElementMF(this.buttons, "body");
    this.deselectElementMF(this.buttons, "astringent");
    this.deselectElementMF(this.buttons, "intensity");
    this.deselectElementMF(this.buttons, "carbonation");
  }

  private deselectElementMF(buttons: Array<any>, elementName: String) {
    let levelOfElement = false;

    for (let b of buttons) {
      let bkey = b.key;
      if (bkey === elementName) {
        levelOfElement = true;
      }
    }

    if (!levelOfElement) {
      //console.log("[beer-hive] MF deselect - not at level of element...");
      for (let b of buttons) {
        if (b.buttons && b.buttons.length > 0) {
          this.deselectElementMF(b.buttons, elementName);
        }
        if (b.detailsChildren && b.detailsChildren.length > 0) {
          let bkey = b.label;
          let keyIndex = elementName.indexOf(bkey);
          if (keyIndex != -1) {
            //eg fruity & fruity_banana
            this.deselectElementMF(b.detailsChildren, elementName);
          }
        }
      }
    } else {
      //console.log("[beer-hive] MF deselect - at level of element!");
      for (let b of buttons) {
        let bkey = b.key;
        if (bkey === elementName) {//!==
          if (b.selected) {
            //debugger;
            console.log("[beer-hive] MF deselecting " + b.key);
            b.selected = false;
            b.value = -1;
          }
          else {
            console.log("[beer-hive] MF deselecting " + b.key + " not needed, item was not selected...");
          }

          //check for children
          if (b.buttons && b.buttons.length > 0) {
            for (let b2 of b.buttons) {
              console.log("[beer-hive] MF deselecting 2 " + b2.key);
              b2.selected = false;
              b2.value = -1;
            }
          }
        }
      }
    }

  }

  private SelectElement(element: any) {

    //debugger;

    if (element.type == ButtonTypes.PARENT || element.type == ButtonTypes.ONE_TO_FIVE_PARENT) {
      this.shouldPublish = false;
    }
    else if (element.type == ButtonTypes.ONE_TO_FIVE_CHILD) {
      this.shouldPublish = true;
    }

    console.log("[beer-hive] SelectElement: element key: " + element.key + " - label: " + element.label);

    if (element.detailsButton && element.buttons) {
      console.log("[beer-hive] we are deselecting 4 " + element.buttons[5].key);
      element.buttons[5].selected = false;
    }

    this.DeselectElements(this.buttons, element);

    if (element.selected) {
      //debugger;
      console.log("[beer-hive] SelectElement - element was already selected => deselecting " + element.key);
      //we also need to remove this from "my" analysis => value 0 instead of 1!
      this.removedItems.push(element.key);
      //door deze in commentaar te zetten lijkt het in orde te zijn
      //voor mouthfeel dan toch
      //verifiëren dat het weghalen van een binair aroma nu ook nog steeds werkt
      //indien niet, andere aanpak (eventueel filteren op type of op key om na te gaan of het mouthfeel of aroma is, ofwel checken op ONE_TO_FIVE_PARENT, ...)
      if (element.key === undefined) {
        element.selected = false;
      }
      else {
        let bkeyindex = element.key.indexOf("_");
        if (bkeyindex != -1)
          element.selected = false;
      }
    } else {
      console.log("[beer-hive] DeselectElements - element was not yet selected, selecting! 1 => " + element.key);
      console.log(element);

      if (element.type == ButtonTypes.ONE_TO_FIVE_CHILD) {
       //debugger;//select 1
        element.parent.selected = true;
      }
      else {
       //debugger;//select 2
        element.selected = true;
      }

      //sometimes (first time clicked) buttons is NO, however, log shows otherwise...
      if (element.detailsButton && element.buttons) {
        console.log("[beer-hive] SelectElement - this button has a child detail button!!!")
        //element.buttons[5].selected=false;
      }
      else {
        console.log("[beer-hive] SelectElement - this button does not have a child detail button...")
      }
      if (element.detailsButton) {
        console.log("[beer-hive] SelectElement - detailsButton YES");
      }
      else {
        console.log("[beer-hive] SelectElement - detailsButton NO");
      }
      if (element.buttons) {
        console.log("[beer-hive] SelectElement - buttons YES");
      }
      else {
        console.log("[beer-hive] SelectElement - buttons NO: " + element.buttons);
      }

      if (element.type === ButtonTypes.ONE_TO_FIVE_CHILD) {
        if (element.thisCell == 0 && element.parent.value !== undefined && element.parent.value === 0) {
          element.parent.value = null;
          console.log("[beer-hive] deselecting 6 " + element.key);
          element.selected = false;
        }
        else {
          console.log("set " + element.parent.key + " to value " + element.thisCell);
          element.parent.value = element.thisCell;
        }
      }
      else if (element.type === ButtonTypes.COLOR_CHILD) {
        element.parent.value = element.color;
      }
      this.DeselectElements(this.buttons, element);
    }
  }

  //deselect the elements
  private DeselectElements(buttons: Array<any>, element: any) {
    console.log("deselectElements " + element.key);
    let levelOfElement = false;
    for (const b of buttons) {
      if (b === element) {
        levelOfElement = true;
      }
    }
    if (!levelOfElement) {
      for (const b of buttons) {
        if (b.buttons && b.buttons.length > 0) {
          this.DeselectElements(b.buttons, element);
        }
      }
    } else {
      for (const b of buttons) {
        if (b !== element) {
          console.log("[beer-hive] DeselectElements " + b.key);
          b.selected = false;
        }
      }
    }

  }

  //draw the color buttons, possibly also showing a bee icon
  private DrawColor(b: any) {
    b.buttons = [];
    let subX = b.x + this.xOffset;
    let subY = b.y - this.yOffsetHalf;
    b.buttons.push({
      type: ButtonTypes.COLOR_CHILD,
      svgPath: "assets/svg/icon_selection_bee.svg",
      color: b.colors[0],
      parent: b,
      x: subX,
      y: subY
    });
    subY += this.yOffsetHalf;
    for (let j = 0; j <= Math.floor((b.colors.length - 1) / 4) - 1; j++) {
      subX += this.xOffset;
      for (let i = j * 4 + 1; i <= j * 4 + 4; i++) {
        b.buttons.push({
          type: ButtonTypes.COLOR_CHILD,
          svgPath: "assets/svg/icon_selection_bee.svg",
          color: b.colors[i],
          parent: b,
          x: subX,
          y: subY
        });
        subY += this.yOffsetFull;
      }
      subY -= this.yOffsetFull * 4 - this.yOffsetHalf;
    }
    for (let sub of b.buttons) {
      if(sub.selected) {
        // the sub is selected
       //debugger;
      }
      this.DrawHexagon(sub.x, sub.y, sub.selected, sub);
      if (sub.color === b.value) {
        this.DrawImage(sub.x, sub.y - this.size / 4, true, sub);
      }
      this.DrawTouchHexagon(sub.x, sub.y, sub);

    }

  }

  //draw the rating cells starting from a button
  private DrawZeroToFive(b: any) {
    console.log("[beer-hive] drawing zero to five for button " + b.label);
    //debugger;

    console.log("[beer-hive] drawing zero to five for button with label/key " + b.key + "/" + b.value);
    console.log("[beer-hive] selected: " + b.selected);
    console.log("[beer-hive] value: " + b.value);

    //let typeOne = ButtonTypes.ONE_TO_FIVE_PARENT;
    //let typeBinary = ButtonTypes.BINARY_ONLY;

    //let legendX: number = 0;
    //let legendY: number = 0;

    b.buttons = [];

    let subX = b.x + this.xOffset;
    let subY = b.y + this.yOffsetHalf;
    b.buttons.push({
      type: ButtonTypes.ONE_TO_FIVE_CHILD,
      svgPath: "assets/svg/minus.svg",
      thisCell: 0,
      parent: b,
      x: subX,
      y: subY
    });
    if (b.type !== ButtonTypes.BINARY_ONLY) {
      this.DrawHexagon(subX, subY, false, b.buttons[0]);
      //this.DrawImage(subX, subY - this.size / 2, false, b.buttons[0]);
      //this.DrawImage(subX, subY, false, b.buttons[0]);
      //of binnen if?
      this.drawLegendOneToFive(b, 0);
      this.DrawTouchHexagon(subX, subY, b.buttons[0]);
      //      this.drawLine(subX, subY);
    }

    subY -= this.yOffsetHalf;
    subX += this.xOffset;
    b.buttons.push({
      type: ButtonTypes.ONE_TO_FIVE_CHILD,
      thisCell: 1,
      parent: b,
      x: subX,
      y: subY
    });
    if (b.type !== ButtonTypes.BINARY_ONLY) {
      this.DrawHexagon(subX, subY, false, b.buttons[1]);
      //of binnen if?
      this.drawLegendOneToFive(b, 1);
      this.DrawTouchHexagon(subX, subY, b.buttons[1]);
    }


    subY += this.yOffsetHalf;
    subX += this.xOffset;
    b.buttons.push({
      type: ButtonTypes.ONE_TO_FIVE_CHILD,
      thisCell: 2,
      parent: b,
      x: subX,
      y: subY
    });
    if (b.type !== ButtonTypes.BINARY_ONLY) {
      this.DrawHexagon(subX, subY, false, b.buttons[2]);
      this.drawLegendOneToFive(b, 2);
      this.DrawTouchHexagon(subX, subY, b.buttons[2]);
    }

    subY += this.yOffsetFull;
    b.buttons.push({
      type: ButtonTypes.ONE_TO_FIVE_CHILD,
      thisCell: 3,
      parent: b,
      x: subX,
      y: subY
    });
    if (b.type !== ButtonTypes.BINARY_ONLY) {
      this.DrawHexagon(subX, subY, false, b.buttons[3]);
      this.drawLegendOneToFive(b, 3);
      this.DrawTouchHexagon(subX, subY, b.buttons[3]);
    }

    subY += this.yOffsetHalf;
    subX -= this.xOffset;
    b.buttons.push({
      type: ButtonTypes.ONE_TO_FIVE_CHILD,
      svgPath: "assets/svg/plus.svg",
      thisCell: 4,
      parent: b,
      x: subX,
      y: subY
    });
    if (b.type !== ButtonTypes.BINARY_ONLY) {
      this.DrawHexagon(subX, subY, false, b.buttons[4]);
      //this.DrawImage(subX, subY - this.size / 2, false, b.buttons[4]);
      //this.DrawImage(subX, subY, false, b.buttons[4]);
      this.drawLegendOneToFive(b, 4);
      this.DrawTouchHexagon(subX, subY, b.buttons[4]);
    }

    // extra text

    if (b.detailsButton) {
      subY -= this.yOffsetFull;
      b.buttons.push({
        type: b.detailsButton.type,
        svgPath: b.detailsButton.svgPath,
        parent: b,
        x: subX,
        y: subY
      });
      if (b.type !== ButtonTypes.BINARY_ONLY) {
        this.DrawHexagon(subX, subY, false, b.buttons[5]);
        this.DrawImage(subX, subY, false, b.buttons[5]);
        this.DrawTouchHexagon(subX, subY, b.buttons[5]);
      }
    }
  }

  private drawLegendOneToFive(b: any, positionValue: number) {
    if (b.type !== ButtonTypes.BINARY_ONLY) {
      let legendX = 0;
      let legendY = 0;
      switch (positionValue) {
        case 4:
          legendX = b.x + 2 * this.xOffset;
          legendY = b.y + 1.5 * this.yOffsetFull;
          break;
        case 3:
          legendX = b.x + 3 * this.xOffset;
          legendY = b.y + 1 * this.yOffsetFull;
          break;
        case 2:
          legendX = b.x + 3 * this.xOffset;
          legendY = b.y + 0 * this.yOffsetFull;
          break;
        case 1:
          legendX = b.x + 2 * this.xOffset;
          legendY = b.y - 0.5 * this.yOffsetFull;
          break;
        case 0:
        default:
          legendX = b.x + 1 * this.xOffset;
          legendY = b.y + 0 * this.yOffsetFull;
          break;
      }
      let legendText: string = this.refdata.getLegendText(positionValue);
      let isActive: boolean = (b.value == positionValue);
      this.DrawLegendString(legendText, legendX, legendY, isActive);
    }
  }
  //draw the detail children
  private DrawDetailChildren(b: any) {
    let subX = b.x + this.xOffset;
    let subY = b.y + this.yOffsetFull * b.startY;
    for (let i = 0; i < b.detailsChildren.length; i += (b.largeRow + b.smallRow)) {
      let first, second;
      if (b.startWithLargeRow) {
        first = b.largeRow;
        second = b.smallRow;
      } else {
        first = b.smallRow;
        second = b.largeRow;
      }
      let j = i;
      for (j = i; j < (i + first) && j < b.detailsChildren.length; j++) {

        b.detailsChildren[j].type = ButtonTypes.DETAILS_CHILD;
        b.detailsChildren[j].parent = b;
        b.detailsChildren[j].x = subX;
        b.detailsChildren[j].y = subY;

        let theB = b.detailsChildren[j];
        if(theB.selected) {
          // the button is selected
         //debugger;
        }

        this.DrawHexagon(subX, subY, b.detailsChildren[j].selected, b.detailsChildren[j]);
        this.DrawImage(subX, subY, b.detailsChildren[j].selected, b.detailsChildren[j]);
        this.DrawTouchHexagon(subX, subY, b.detailsChildren[j]);

        subY += this.yOffsetFull;
      }

      subX += this.xOffset;
      subY = b.y + this.yOffsetFull * b.startY + (b.startWithLargeRow ? this.yOffsetHalf : -this.yOffsetHalf);

      for (; j < (i + first + second) && j < b.detailsChildren.length; j++) {

        b.detailsChildren[j].type = ButtonTypes.DETAILS_CHILD;
        b.detailsChildren[j].parent = b;
        b.detailsChildren[j].x = subX;
        b.detailsChildren[j].y = subY;

        let theB = b.detailsChildren[j];
        if(theB.selected) {
          // button is selected
         //debugger;
        }
        this.DrawHexagon(subX, subY, b.detailsChildren[j].selected, b.detailsChildren[j]);
        this.DrawImage(subX, subY, b.detailsChildren[j].selected, b.detailsChildren[j]);
        this.DrawTouchHexagon(subX, subY, b.detailsChildren[j]);

        subY += this.yOffsetFull
      }
      subX += this.xOffset;
      subY = b.y + this.yOffsetFull * b.startY;
    }
  }

  private drawLine(x: number, y: number) {
    this.buildingSvg += this.svgProvider.drawLegendLine(x, y);
  }
  //draw a string at a specific position, with a specific color, rotation, font (size)
  private DrawString(text, posX, posY, textColor, rotation, font, fontSize) {
    if (text) {

      //let lines = text.split("\n");
      if (!rotation) rotation = 0;
      if (!font) font = "'serif'";
      if (!fontSize) fontSize = 16;
      //fontSize = 16;
      if (!textColor) textColor = this.refdata.defaultFontColor;

      var textX = posX;
      var textY = posY + this.size;
      var iText = this.svgProvider.drawAromaText(text, textX, textY);
      this.buildingSvg += iText;
    }
  }
  //draw a string at a specific position, with a specific color, rotation, font (size)
  private DrawLegendString(text, posX, posY, isActive: boolean) {
    if (text) {

      var textX = posX;
      var textY = posY + this.size;
      var iText = this.svgProvider.drawLegendText(text, textX, textY, isActive);
      this.buildingSvg += iText;
    }
  }

  private svgRootElement() {

    return '<svg xmlns:i="http://ns.adobe.com/AdobeIllustrator/10.0/"' +
      ' xmlns:dc="http://purl.org/dc/elements/1.1/"' +
      ' xmlns:cc="http://creativecommons.org/ns#"' +
      ' xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"' +
      ' xmlns:svg="http://www.w3.org/2000/svg"' +
      ' xmlns="http://www.w3.org/2000/svg"' +
      ' xmlns:xlink="http://www.w3.org/1999/xlink"' +
      ' xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"' +
      ' id="beer-hive-svg-svg" version="1.1" ' + this.svgViewAttributes(0, 0, this.bhutil.hiveWidth(), this.bhutil.hiveHeight()) + '>' +
      '';
  }

  private svgViewAttributes(x, y, width, height) {
    return 'viewBox="' + x + ' ' + y + ' ' + width + ' ' + height + '"' +
      ' height="' + height + '" width="' + width + '"';
  }

}
